import React from 'react';

import { useMREState } from '../../hooks/useMREState';

interface ShowWhenFlyoverActiveProps {
  children: React.ReactNode;
}

export const ShowWhenFlyoverActive = ({
  children
}: ShowWhenFlyoverActiveProps) => {
  const { isFlyoverInProgress } = useMREState();
  return isFlyoverInProgress ? <>{children}</> : null;
};
